
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import itemMixin from '@/minix/itemMixin';
import Swal from 'sweetalert2';

const { report, store } = api;
@Component({ components: { DateRange } })
export default class StoreSummary extends Mixins(Vue.extend(itemMixin)) {
  private data = {
    data: [],
    totalPoints: 0,
    totalCount: 0,
    pageSize: 20,
    pageNo: 0,
  };

  private panel = 0;

  private loading = false;

  private storeOptions: any = [];

  merchantList: Merchant[] = [];

  private headers = [
    { text: '消費日期', value: 'date', width: 160 },
    { text: '供應商名稱', value: 'merchantName', width: 160 },
    { text: '店家', value: 'storeName', width: 100 },
    { text: '消費總金額', value: 'price', width: 120 },
    { text: '折價總金額', value: 'discount', width: 100 },
    { text: '點數總折抵', value: 'usePoint', width: 120 },
    { text: '其他點數總折抵', value: 'otherPoint', width: 120 },
    { text: '電子支付總金額', value: 'thirdPartyPay', width: 120 },
    { text: '現金支付總額', value: 'cash', width: 120 },
    { text: '匯出', value: 'export', width: 120 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private get merchantSelectOptions() {
    this.storeOptions = [];
    const mcId = this.filter.merchantCategoryId;
    return this.merchantList
      .filter((m: any) => !mcId || mcId === m.categoryId)
      .map((m: any) => ({
        text: m.merchantName,
        value: m.merchantId,
      }));
  }

  private filter = {
    merchantCategoryId: Util.isNullOrUndefined(
      this.$route.query.merchantCategoryId,
    )
      ? undefined
      : this.$route.query.merchantCategoryId,
    merchantId: Util.isNullOrUndefined(this.$route.query.merchantId)
      ? undefined
      : +this.$route.query.merchantId,
    storeId: Util.isNullOrUndefined(this.$route.query.storeId)
      ? undefined
      : this.$route.query.storeId,
    startDate: this.$route.query.startDate || undefined,
    endDate: this.$route.query.endDate || undefined,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async bindStoreSelectOption(merchantId: string) {
    if (!!merchantId) {
      const { data: { data } } = await store.list(merchantId, { pageSize: 0, pageNo: 1 }) || [];
      this.storeOptions = data.map((v:any) => ({
        text: v.storeName,
        value: v.storeId,
      }));
    }
  }

  private async updatePage(page: number) {
    await this.query(`${this.pager.pageNo = page}`);
  }

  private async query(page: string) {
    const pageNo = (typeof page === 'string' ? page : null) || `${this.pager.pageNo = 1}`;
    const query = {
      ...this.filter,
      merchantId: this.filter.merchantId
        ? `${this.filter.merchantId}`
        : undefined,
      pageSize: `${this.pager.pageSize}`,
      pageNo,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      merchantCategoryId: undefined,
      merchantId: undefined,
      storeId: undefined,
      startDate: undefined,
      endDate: undefined,
    };
    this.pager = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query('1');
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async handleExport(id: any) {
    const { status, data } = await report.storeSummaryFileLink(id);
    if (status === 1) {
      window.open(data, '_blank');
    } else {
      await Swal.fire({ icon: 'warning', title: '無法取得檔案，請聯繫系統管理員。' });
    }
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.filter, ...this.pager };
    const { status, data } = await report.storeDailyPaymentSummery(filter);
    if (status === 1) {
      this.data = data;
    }
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: StoreSummary) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
